// extracted by mini-css-extract-plugin
export default {"center":"Loader_center__A1yow"};